module.exports = __webpack_public_path__ + "fonts/fa-solid-900.56df75b6.woff";